<template>
  <div class="container processSensory">
    <el-row style="margin: 20px 0 20px 0">
      <el-button v-if="!disabled&&['edit','change'].includes($route.query.type)" v-acl="PROC_LOT_RECORD_ADD" type="primary" @click="save()">{{$t("visitPlan.draftSave")}}</el-button>
      <el-button v-if="!disabled&&!needUpdateReason&&['edit','change'].includes($route.query.type)" v-acl="PROC_LOT_RECORD_ADD" type="primary" @click="submit()">{{$t("common.submit")}}</el-button>
      <!-- 变更提交 -->
      <el-button v-if="!disabled&&needUpdateReason&&['edit','change'].includes($route.query.type)" v-acl="PROC_LOT_RECORD_ADD" type="primary" @click="changeSubmit()">{{$t("common.submit")}}</el-button>
      <el-button type="primary" @click="$router.push({name:'processSensoryReportList'})">{{$t("common.close")}}</el-button>
    </el-row>
    <el-tabs v-model="firstActiveName" @tab-click="firstHandleClick">
      <el-tab-pane label="基础信息" name="basicInfo">
        <el-form :model="report" ref="report" label-width="150px">
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item label="单据编号">
                <el-input class="handle-input" v-model="report.reportNo" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="版本">
                <el-input class="handle-input" v-model="report.version" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="产品" prop="fiveBitCodeName">
                <el-tooltip class="item" effect="dark" :content="report.fiveBitCodeName" v-if="report.fiveBitCodeName&&report.fiveBitCodeName.length>13" placement="top-start">
                  <el-input class="handle-input" v-model="report.fiveBitCodeName" disabled></el-input>
                </el-tooltip>
                <el-input class="handle-input" v-model="report.fiveBitCodeName" disabled v-else></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Facility编号">
                <el-input class="handle-input" v-model="report.supplierCode" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Facility名称">
                <el-input class="handle-input" v-model="report.plantName" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="评估人" prop="rater">
                <el-input class="handle-input" v-model="report.rater" disabled>
                  <i slot="append" class="el-icon-success" style="color:green" v-if="report.raterQualified=='Y'"></i>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item label="生产日期" prop="prodDate">
                <el-date-picker value-format="yyyy-MM-dd" type="date" v-model="report.prodDate" disabled></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="Sample Source" prop="sampleSource">
                <ic-select table="TT_PROCESS_SENSORY" field="SAMPLE_SOURCE" v-model="report.sampleSource" disabled></ic-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="24">
              <el-form-item :label="$t('common.remarks')" prop="remark">
                <el-input class="handle-input" type="textarea" v-model="report.remark" clearable maxlength="200" :disabled="disabled||['view'].includes($route.query.type)"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="评估明细" name="evaluationDetail">
        <el-row>
          <el-button type="primary" @click="changeShow">{{isShow?'隐藏标准':'查看标准'}}</el-button>
          <el-button type="primary" @click="onImport" v-if="!disabled&&['edit','change'].includes($route.query.type)" v-acl="PROC_LOT_RECORD_ADD">导入</el-button>
          <el-button type="primary" @click="onExport" v-if="!disabled&&['edit','change'].includes($route.query.type)" v-acl="PROC_LOT_RECORD_ADD">导出</el-button>
        </el-row>
        <el-form :model="tableForm" ref="tableForm" style="padding:10px 0" class="scoreTable">
          <el-table :data="tableForm.templateData" ref="scoreTable" min-height="500px" :span-method="spanMethod" border :key="tableKey" :row-class-name="rowClassNameFun" :cell-class-name="cellClassNameFun">
            <el-table-column prop="title" label="名称" width="160" fixed show-overflow-tooltip align="center"></el-table-column>
            <el-table-column label="标准" v-if="isShow" class-name="template-detail" min-width="380px">
              <template slot-scope="scope">
                <div v-if="scope.row.detailType == 'TITLE'">{{scope.row.detail}}</div>
                <div v-else-if="scope.row.detailType == 'SCORE'">{{scope.row.detail}}</div>
                <div v-else>
                  <div v-if="scope.row.isComments == 'Y'">{{scope.row.detail}}</div>
                  <div v-if="scope.row.isComments != 'Y'">
                    <div class="template-detail-cell row1" v-for="i in 9" :key="i+'1'">{{scope.row.detail.split('`')[i-1]==''?" 　":scope.row.detail.split('`')[i-1]}}</div>
                    <div class="template-detail-cell row2" v-for="i in 9" :key="i+'2'">
                      {{(scope.row.start > i||scope.row.end < i)?"  ":i}}
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column v-for="(batch,batchIndex) of tableForm.tableHeadData" :key="'ab'+batchIndex+initialKey" min-width="300px" align="center" header-align="center">
              <template slot="header" slot-scope="scope">
                <div class="table_header_grandFather">
                  <div class="table_header_father">
                    <div class="table_header_input">
                      <div class="table_header_input_label" v-if="batchIndex==0">
                        <p>评估类型:</p>
                      </div>
                      <div class="'table_header_input_content1'" style="width: calc(100% - 60px) !important">
                        <ic-select table="TT_PROCESS_SENSORY" field="RATE_TYPE" v-model="tableForm.tableHeadData[batchIndex].rateType" disabled clearable style="width:100%;padding:0px!important"></ic-select>
                      </div>
                    </div>
                    <div class="table_header_input">
                      <div class="table_header_input_label" v-if="batchIndex==0">
                        <p>批次号:</p>
                      </div>
                      <div class="'table_header_input_content1'" style="width: calc(100% - 60px) !important">
                        <el-input v-model="tableForm.tableHeadData[batchIndex].batchNoWithStatus" disabled style="width:100%;padding:0px"></el-input>
                      </div>
                    </div>
                    <div class="table_header_input" v-show="isShowMore">
                      <div class="table_header_input_label" v-if="batchIndex==0">
                        <p><i class="mandatory"></i>评估日期:</p>
                      </div>
                      <div class="'table_header_input_content1'" style="width: calc(100% - 60px) !important">
                        <el-date-picker @change="rateDateChange(tableForm.tableHeadData[batchIndex].rateDate,batchIndex)" value-format="yyyy-MM-dd" type="date" v-model="tableForm.tableHeadData[batchIndex].rateDate" :key="batchIndex + initialKey" :disabled="disabled||['view'].includes($route.query.type)" style="width:100%;padding:0px"></el-date-picker>
                      </div>
                    </div>
                    <div class="table_header_input" v-show="isShowMore">
                      <div class="table_header_input_label" v-if="batchIndex==0">
                        <p>保质期:</p>
                      </div>
                      <div class="'table_header_input_content1'" style="width: calc(100% - 60px) !important">
                        <el-input :disabled="disabled||['view'].includes($route.query.type)" v-model="tableForm.tableHeadData[batchIndex].expDate" :key="batchIndex + initialKey" style="width:100%;padding:0px"></el-input>
                      </div>
                    </div>
                    <div class="table_header_input" v-show="isShowMore">
                      <div class="table_header_input_label" v-if="batchIndex==0">
                        <p>样品代码:</p>
                      </div>
                      <div class="'table_header_input_content1'" style="width: calc(100% - 60px) !important">
                        <el-input :disabled="disabled||['view'].includes($route.query.type)" v-model="tableForm.tableHeadData[batchIndex].sampleCode" :key="batchIndex + initialKey" type="textarea" maxlength="200" show-word-limit style="width:100%;padding:0px"></el-input>
                      </div>
                    </div>
                  </div>
                  <i style="color:#f8ab01;display:inline-block;width:14px;height:auto" @click="onShowMore" :class="isShowMore?'el-icon-arrow-up':'el-icon-arrow-down'" circle></i>
                </div>
              </template>
              <template slot-scope="scope">
                <el-form-item style="display: inline-block;width: 60%;" v-if="scope.row.detailType != 'TITLE' && scope.row.detailType != 'SCORE' && scope.row.isComments == 'Y'" :prop="`tableHeadData[${batchIndex}].scores[${scope.row.index}]`" :rules="scoreRules.score2">
                  <el-input type="textarea" :disabled="disabled||['view'].includes($route.query.type)" v-model="batch.scores[scope.row.index]" :placeholder='scoresPlaceholder(disabled)'></el-input>
                </el-form-item>
                <el-form-item style="display: inline-block;width: 60%;" v-if="scope.row.detailType != 'TITLE' && scope.row.detailType != 'SCORE' && scope.row.isComments != 'Y'" :prop="`tableHeadData[${batchIndex}].scores[${scope.row.index}]`" :rules="scoreRules.score">
                  <el-input class="score" :max="scope.row.end" :min="scope.row.start" :disabled="disabled||['view'].includes($route.query.type)" v-model="batch.scores[scope.row.index]"></el-input>
                </el-form-item>
                <span v-if="scope.row.detailType == 'SCORE'">{{countScore(scope.row.scoreField,batch)}}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="附件" name="attachment">
        <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick" style="margin-top:10px">
          <el-tab-pane label="产品照片" name="picture">
            <el-upload ref="picture" :headers="header" :action="fileUploadUrl" :file-list="picList" :on-success="uploadSuccess" accept=".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP" :disabled="disabled||['view'].includes($route.query.type)" multiple list-type="picture-card">
              <i class="el-icon-plus"></i>
              <div slot="file" slot-scope="{file}" style="height: 100%">
                <img :src="file.url" alt="" style="max-width:100%;height:auto;object-fit:contain">
                <span class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-preview" @click="handlePreview(file)">
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span v-if="file.tmDocumentId" class="el-upload-list__item-delete" @click="downloadFile(file)">
                    <i class="el-icon-download"></i>
                  </span>
                  <span v-if="!disabled&&['edit','change'].includes($route.query.type)" class="el-upload-list__item-delete" @click="fileRemove(file)">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload>
          </el-tab-pane>
          <el-tab-pane label="产品附件" name="file">
            <el-row style="margin-bottom:10px">
              <el-upload :show-file-list="false" ref="upload" :headers="header" :action="fileUploadUrl" :before-upload="beforeUpload" :on-success="uploadSuccess" :multiple="true" v-if="!disabled&&['edit','change'].includes($route.query.type)" v-acl="PROC_LOT_RECORD_ADD">
                <el-button type="primary">{{$t("common.upload")}}</el-button>
              </el-upload>
            </el-row>
            <el-table :data="fileTableData" border stripe style="width: 100%">
              <el-table-column prop="documentName" label="附件">
                <template slot-scope="scope">
                  <el-button @click="downloadFile(scope.row)" type="text" size="small">{{scope.row.documentName}}</el-button>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="180" v-if="!disabled&&['edit','change'].includes($route.query.type)">
                <template slot-scope="scope">
                  <el-button @click="delFile(scope.row,scope.$index,'file')" type="text" size="small"><i class="el-icon-delete" style="color:red"></i>删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-tab-pane>
      <el-tab-pane label="操作日志" name="operationLog">
        <el-table :data="workFlowLogs" stripe border style="width: 100%">
          <el-table-column prop="createDate" label="操作时间" width="180"></el-table-column>
          <el-table-column prop="operatorName" label="用户名称" width="180"></el-table-column>
          <el-table-column prop="action" label="操作"></el-table-column>
          <el-table-column prop="comments" label="变更原因"></el-table-column>
        </el-table>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :visible.sync="dialogVisible" style="text-align:center">
      <img style="height:100%;width:100%" :src="dialogImageUrl" alt="">
    </el-dialog>
    <el-dialog title="变更品评报告" :visible.sync="submitDialogVisible" :close-on-click-modal="false" :close-on-press-escape="false" @close="closeDialog">
      <el-form :model="changeForm" :rules="changeFormRules" ref="formRef" label-width="120px">
        <el-form-item label="选中单据" prop="reportNo">
          <el-input v-model="changeForm.reportNo" disabled></el-input>
        </el-form-item>
        <el-form-item label="变更原因" prop="updateReason">
          <el-input v-model="changeForm.updateReason" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" show-word-limit maxlength="1000"></el-input>
        </el-form-item>
      </el-form>
      <el-row type="flex" align="middle" justify="center">
        <el-button type="primary" @click="submitForm">确定变更</el-button>
        <el-button @click="onCancel">取消</el-button>
      </el-row>
    </el-dialog>
    <el-dialog title="批量导入" :visible.sync="dialogBatchUploadVisible" width="40%" :close-on-click-modal="false" @close="onCloseUpload">
      <el-row style="margin-bottom:10px">
        <el-upload ref="batchUpload" :headers="header" :action="uploadListsUrl" :on-success="uploadListsSuccess" :on-error="uploadError" :on-change="handleChange" :before-upload="beforeListsUpload" :file-list="fileList" :auto-upload="false" :show-file-list="false" style="display:inline-block;margin-right:10px">
          <el-button size="small" type="primary">选取文件</el-button>
        </el-upload>
        <el-button class="btn" type="primary" size="small" style="height:100%" @click="onDownload">导入模板下载</el-button>
      </el-row>
      <el-form :model="uploadForm" ref="uploadForm">
        <el-form-item>
          <el-input v-model="uploadForm.fileName" readonly></el-input>
        </el-form-item>
      </el-form>
      <el-row>
        <h4>说明:</h4>
        <ul>
          <li>1.请点击模板下载,按照模板填写后再上传</li>
          <li>2.模板中红色字段为必填项,请务必正确填写</li>
          <li>3.仅支持上传Excel格式文件,且大小不能超过20M</li>
          <li>4.为保证上传成功,请勿对模板中的单元格进行修改</li>
          <li>5.一次仅支持一份文件上传,多份文件上传将会替换原文件</li>
        </ul>
      </el-row>
      <el-row type="flex" justify="center">
        <el-button size="mini" class="btn" type="primary" @click="onUpload">上传</el-button>
        <el-button size="mini" class="btn" type="primary" @click="onClose1">关闭</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import reportApi from "@/api/sensory/processReport";
import pickupUser from "@/components/page/sensory/sensory-template/choiceUser";
import IcSelect from "@/components/common/icSelect";
import PickupFiveBitCode from "./templateName.vue";
import commonFun from "@/utils/commonFun";
import FileUpload from "@/components/common/fileUpload";
import { Message } from "element-ui";
import PickupPlant from "@/components/page/sensory/pickupPlant";
import PickupPlantMulti from "@/components/page/sensory/pickupPlantMulti";
import commonConstatns from "@/constants/commonConstants";
import { fileService } from "@/api/common/file-utils"
export default {
  name: "processSensoryReportDetail",
  components: { PickupPlantMulti, PickupPlant, FileUpload, PickupFiveBitCode, IcSelect, pickupUser },
  data() {
    var validatorScore2 = (rule, value, callback) => {
      if (value && value.indexOf("；") != -1) {
        return callback(new Error("不能输入分号"));
      }
      if (value && value.indexOf(";") != -1) {
        return callback(new Error("不能输入分号"));
      }
      if (value && value.indexOf(".") != -1) {
        return callback(new Error("不能输入句号"));
      }
      if (value && value.indexOf("。") != -1) {
        return callback(new Error("不能输入句号"));
      }
      if (value) {
        var arr = value.split(/[(|（].*?[）|)]/);
        arr.some(function (value, index) {
          if (value.indexOf(" ") != -1 || value.indexOf("　") != -1) {
            return callback(new Error("内容中不能输入空格"));
          }
        });
      }
      callback();
    };

    return {
      firstActiveName: "basicInfo",
      activeName: "picture",
      report: {
      },
      tableForm: {
        templateData: [],
        tableHeadData: []
      },
      isShowMore: false,
      sensoryReportPlantBatchs: [],
      sensoryReportPlants: [],
      reportDetail: null,
      // templateData: [],
      // tableHeadData: [],
      appearanceIndex: null,
      textureIndex: null,
      flavorIndex: null,
      disabled: true,
      scoreRules: {
        score: [{ type: 'number', validator: this.scoreRange, trigger: ["change", "blur"] }],
        score2: [{ type: 'number', validator: validatorScore2, trigger: ["change", "blur"] }]
      },
      raterLists: [{ value: "QA LAB" }],
      isShow: true,
      picTableData: [],
      picList: [],
      fileTableData: [],
      fileUploadUrl: null,
      dialogImageUrl: '',
      dialogVisible: false,
      tableKey: Date.now(),// 避免key重复的初始值
      initialKey: 0,// 避免key重复的初始值
      workFlowLogs: [],
      submitDialogVisible: false,
      changeForm: {
        reportNo: "",
        updateReason: ""
      },
      changeFormRules: {
        updateReason: [{ required: true, message: "请输入变更原因", trigger: "blur" }],
      },
      sensoryReportId: "",
      dialogBatchUploadVisible: false,
      header: {
        'x-access-token': localStorage.getItem('token')
      },
      uploadListsUrl: null,
      fileList: [],
      uploadForm: {
        fileName: "",
      },
      version: null,
      rootReportId: "",
      needUpdateReason: false
    }
  },
  created() {
    this.report.rater = localStorage.getItem('ms_username')
    if (this.$route.name == 'processSensoryReportDetail') {
      this.getData();
    } else {
      this.disabled = false;
      console.log("新建页disabled值：", this.disabled); // 确认是否为false
      this.initialKey = 0; // 新增：更新key，强制表头重新渲染
    }
  },
  computed: {
    countScore() {
      return (scoreField, batch) => {
        let detailType = null;
        switch (scoreField) {
          case 'AppearanceScore':
            detailType = "APPEARANCE";
            break;
          case 'TextureScore':
            detailType = "TEXTURE";
            break;
          case 'FlavorScore':
            detailType = "FLAVOR";
            break;
          case 'QualityScore':
            detailType = "ALL";
            break;
        }
        let scores = this.tableForm.templateData.filter((templatDetail, index, arr) => {
          return templatDetail.isComments != 'Y';
        }).filter((templatDetail, index, arr) => {
          if (detailType == "ALL") {
            return templatDetail.detailType == "APPEARANCE" || templatDetail.detailType == "TEXTURE" || templatDetail.detailType == "FLAVOR";
          } else {
            return templatDetail.detailType == detailType;
          }
        }).map((templatDetail, index, arr) => {
          return batch.scores[templatDetail.index];
        })
        let count19 = scores.filter(value => value == 1 || value == 9).length;
        let count28 = scores.filter(value => value == 2 || value == 8).length;
        let count37 = scores.filter(value => value == 3 || value == 7).length;
        let count46 = scores.filter(value => value == 4 || value == 6).length;
        let count5 = scores.filter(value => value == 5).length;
        let res = 0;
        if (count19 > 0) {
          res = 0;
        } else if (count28 > 0) {
          res = 25;
        } else if (count37 > 0) {
          res = 60 + (count5 > 0 ? (count5 / (scores.length - 1) * 20) : 0) + (count46 > 0 ? (count46 / (scores.length - 1) * 10) : 0);
        } else if (count46 > 0) {
          res = 85 + (count5 > 0 ? (count5 / (scores.length - 1) * 10) : 0);
        } else if (count5 > 0) {
          res = 100;
        }
        return Math.round(res) + "%";
      };
    }
  },
  methods: {
    getData() {
      let reportId = this.$route.query.id;
      reportApi.getDetail(reportId).then(resp => {
        let data = resp.data;
        let report = data.sensoryReport;
        this.version = report.version
        this.report = report;//基础信息
        this.report.version = 'v' + this.report.version
        this.needUpdateReason = data.needUpdateReason
        this.workFlowLogs = data.workFlowLogs
        this.sensoryReportId = report.ttSensoryReportId
        this.rootReportId = report.rootReportId
        this.fileUploadUrl = this.rootReportId ? commonConstatns.fileUploadUrl + `/PROCESS_SENSORY_REPORT/${this.rootReportId}/` : this.$route.query.id ? commonConstatns.fileUploadUrl + `/PROCESS_SENSORY_REPORT/${this.$route.query.id}/` : commonConstatns.fileUploadUrl
        let tableHeadData = []
        //评估明细
        if (commonFun.isNotEmpty(report.template)) {
          this.initTemplateData(report.template);
        }
        // 计算模板中可输入项的数量（非标题和总分行）
        const inputableCount = this.tableForm.templateData.filter(item =>
          item.detailType !== 'TITLE' && item.detailType !== 'SCORE'
        ).length;
        console.log('inputableCount :', inputableCount);
        data.sensoryReportPlantBatchs.forEach(batch => {
          // 格式化日期
          batch.rateDate = this.formatDate(batch.rateDate);
          // 初始化保质期（确保响应式）
          this.$set(batch, 'expDate', batch.expDate || '');
          // 初始化样品代码（关键：通过$set确保响应式）
          this.$set(batch, 'sampleCode', batch.sampleCode || '');
          // 初始化scores数组（关键：确保长度与templateData匹配）
          if (commonFun.isNotEmpty(batch.score)) {
            batch.scores = batch.score.split(";").map(value => commonFun.isEmpty(value) ? '' : value);
          } else {
            // 初始化为充满''的数组，长度与可输入项一致
            batch.scores = Array(inputableCount).fill('');
          }
          if (commonFun.isNotEmpty(batch.lastScore)) {
            batch.lastScores = batch.lastScore.split(";").map(value => commonFun.isEmpty(value) ? '' : value);
          } else {
            batch.lastScores = Array(inputableCount).fill('');
          }
          tableHeadData.push(batch);
        })
        this.tableForm.tableHeadData = [...tableHeadData];
        console.log('this.tableForm.tableHeadData :', this.tableForm.tableHeadData);
        this.sensoryReportPlantBatchs = data.sensoryReportPlantBatchs;
        this.disabled = !data.canEdit;
        this.getFileList()
        this.initialKey = 0; // 新增：更新key，强制表头重新渲染
        // 数据更新后重新计算表格布局
        this.$nextTick(() => {
          this.$refs["scoreTable"].doLayout();
        });
      })
    },
    // 格式化函数示例
    formatDate(dateStr) {
      if (!dateStr) return '';
      return dateStr.split(' ')[0]; // 截取日期部分
    },
    //评估明细
    initTemplateData(template) {
      console.log('template :', template);
      this.tableForm.templateData = [];
      let templateDetails = template.templateDetails || [];
      this.appearanceIndex = null;
      this.textureIndex = null;
      this.flavorIndex = null;
      // 排序模板详情
      const sortedDetails = commonFun.deepCopy(templateDetails).sort((a, b) => {
        if (a.detailType === b.detailType) return a.sort - b.sort;
        if (a.detailType === 'APPEARANCE') return -1;
        if (a.detailType === 'TEXTURE') {
          return b.detailType === 'APPEARANCE' ? 1 : -1;
        }
        return 1;
      });
      console.log('13123', this.tableForm.templateData);

      // 处理每行数据，添加index（关键：与scores数组索引对应）
      sortedDetails.forEach((tmpDtl, index) => {
        tmpDtl.index = index;// 记录索引，用于scores数组关联
        // 添加分类标题行
        if (this.appearanceIndex == null && tmpDtl.detailType == "APPEARANCE") {
          this.appearanceIndex = index;
          this.tableForm.templateData.push({
            title: 'Appearance:',
            detailType: 'TITLE',
            detail: template.appearanceDesc,
          });
        }
        if (this.textureIndex == null && tmpDtl.detailType == "TEXTURE") {
          this.textureIndex = index;
          this.tableForm.templateData.push({
            title: 'Texture/ Mouthfeel',
            detailType: 'TITLE',
            detail: template.textureDesc,
          });
        }
        if (this.flavorIndex == null && tmpDtl.detailType == "FLAVOR") {
          this.flavorIndex = index;
          this.tableForm.templateData.push({
            title: 'Aroma/ Flavor:',
            detailType: 'TITLE',
            detail: template.flavorDesc,
          });
        }
        // 处理分数范围
        if (commonFun.isNotEmpty(tmpDtl.detail) && tmpDtl.isComments == 'N') {
          let split = tmpDtl.detail.split('`');
          let start = 0, end = 0;
          split.forEach((item, i) => {
            if (commonFun.isNotEmpty(item)) {
              start = start || i + 1;
              end = i + 1;
            }
          });
          tmpDtl.start = start;
          tmpDtl.end = end;
        }
        this.tableForm.templateData.push(tmpDtl);
      })
      // 添加总分行
      this.tableForm.templateData.push({
        title: this.$t("sensory.report.productQualityScore"),
        detailType: "SCORE",
        scoreField: "QualityScore",
        index: this.tableForm.templateData.length
      })
      // 补充分类总分行
      let haveA = false, haveT = false, haveF = false;
      for (let i = this.tableForm.templateData.length - 1; i >= 0; i--) {
        let currentData = this.tableForm.templateData[i];
        if (!haveA && currentData.detailType == 'APPEARANCE' && this.tableForm.templateData[i + 1].detailType != 'APPEARANCE') {
          this.tableForm.templateData.splice(i + 1, 0, { title: this.$t("sensory.report.overallAppearanceScore"), detailType: "SCORE", scoreField: "AppearanceScore" });
          haveA = true;
        }
        if (!haveT && currentData.detailType == 'TEXTURE' && this.tableForm.templateData[i + 1].detailType != 'TEXTURE') {
          this.tableForm.templateData.splice(i + 1, 0, {
            title: this.$t("sensory.report.overallTextureScore"),
            detailType: "SCORE",
            scoreField: "TextureScore"
          });
          haveT = true;
        }
        if (!haveF && currentData.detailType == 'FLAVOR' && this.tableForm.templateData[i + 1].detailType != 'FLAVOR') {
          this.tableForm.templateData.splice(i + 1, 0, {
            title: this.$t("sensory.report.overallFlavorScore"),
            detailType: "SCORE",
            scoreField: "FlavorScore"
          });
          haveF = true;
        }
      }
      this.$refs["scoreTable"].doLayout();
      console.log('this.tableForm.templateData 22:', this.tableForm.templateData);
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (rowIndex % 2 === 0) {
        if (columnIndex === 0) {
          return [1, 2];
        } else if (columnIndex === 1) {
          return [0, 0];
        }
      }
    },
    getFileList() {
      let attachment = {};
      attachment.seq = '';
      attachment.tsRecId = this.rootReportId ? this.rootReportId : this.$route.query.id ? this.$route.query.id : null;
      attachment.tsReckindId = 'PROCESS_SENSORY_REPORT';
      attachment.attachmentName = '';
      this.fileTableData = []
      this.picTableData = []
      this.picList = []
      fileService.getFileList(attachment).then(res => {
        console.log('res :', res);
        if (res && res.length > 0) {
          res.forEach(ele => {
            if (ele.downloadType.startsWith('image/')) {
              this.picList.push({
                name: ele["documentName"],
                url: '/adminconsole/file/downloadByKey?key=' + ele["documentKey"],
                documentName: ele["documentName"],
                downloadType: ele["downloadType"],
                tmDocumentId: ele["tmDocumentId"]
              })
              this.picTableData.push(ele)
            } else {
              this.fileTableData.push(ele)
            }
          })
          console.log('this.picTableData :', this.picTableData);
          console.log('this.fileTableData :', this.fileTableData);
        }
      });
    },
    uploadListsSuccess(resp) {
      if (resp.meta.code == 200) {
        this.$message.success('您已成功导入数据');
        this.getData();
      } else {
        this.$message.success(resp.meta.message);
        this.$refs.batchUpload.clearFiles();
      }
      this.dialogBatchUploadVisible = false
      this.fileList = []
      this.uploadForm.fileName = ''
    },
    uploadError(resp) {
      if (undefined != resp.message) {
        let res = JSON.parse(resp.message);
        this.$message.error(res.msg);
      } else {
        this.$message.error("文件上传失败,请检查后重试！");
      }
    },
    handleChange(file, fileList) {
      if (fileList.length > 0) {
        this.fileList = [fileList[fileList.length - 1]]  // 这一步，是 展示最后一次选择的csv文件
      }
      this.uploadForm.fileName = file.name
    },
    beforeListsUpload(file) {
      var isExcel = true
      if (file.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || file.type == "application/vnd.ms-excel") {
        isExcel = true
      } else {
        isExcel = false
      }
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isExcel) {
        this.$my_message('请选择Excel文件上传', 'error');
      }
      if (!isLt50M) {
        this.$my_message('附件大小不得超过50M', 'error');
      }
      return isExcel && isLt50M;
    },
    onUpload() {
      this.$refs.batchUpload.submit();
    },
    onClose1() {
      this.dialogBatchUploadVisible = false
      this.uploadForm.fileName = ''
      this.fileList = []
    },
    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    downloadFile(file) {
      fileService.downloadFile(file);
    },
    delFile(file, index, type) {
      if (commonFun.isEmpty(file.tmDocumentId)) {
        this.fileTableData.splice(index, 1)
        return;
      }
      fileService.deleteFile(file.tmDocumentId).then(res => {
        if (res.code == '200') {
          this.fileTableData = this.fileTableData.filter((tmp, i) => {
            return tmp.tmDocumentId !== file.tmDocumentId
          })
          this.$message.success('删除成功')
        }
      });
    },
    fileRemove(file) {
      if (!file.tmDocumentId) {
        for (let i = 0; i < this.picTableData.length; i++) {
          if (this.picTableData[i].documentName == file.name) {
            this.picTableData.splice(i, 1)
          }
        }
        let allFile = this.$refs.picture.$data.uploadFiles;
        this.removeTempFile(allFile, file);
        return;
      }
      fileService.deleteFile(file.tmDocumentId).then(res => {
        if (res.code == '200') {
          for (let i = 0; i < this.picTableData.length; i++) {
            if (this.picTableData[i].documentName == file.documentName) {
              this.picTableData.splice(i, 1)
            }
          }
          let allFile = this.$refs.picture.$data.uploadFiles;
          this.removeTempFile(allFile, file);
          this.$message.success('删除成功')
        }
      });
    },
    // 删除页面缩略图
    removeTempFile(allFile, file) {
      if (!!allFile) {
        for (let j = 0; j < allFile.length; j++) {
          if (allFile[j].name == file.name) {
            allFile.splice(j, 1)
          }
        }
      }
    },
    // 图片类型黑名单检测
    isImageFile(file) {
      const imageMimes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp']
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp']

      // 双重验证机制
      const isMimeImage = imageMimes.includes(file.type)
      const ext = file.name.split('.').pop().toLowerCase()
      const isExtImage = imageExtensions.includes(ext)

      return isMimeImage || isExtImage
    },
    // 上传前拦截
    beforeUpload(file) {
      if (this.isImageFile(file)) {
        this.$message.error('不允许上传图片')
        return false
      }
      return true
    },
    uploadSuccess(response, file, fileList) {
      if (response.code == '200') {
        if (response.data[0].downloadType.startsWith('image/')) {
          this.picTableData.push(response.data[0])
        } else {
          this.fileTableData.push(response.data[0])
        }
        this.$message.success('上传成功')
      }
    },
    firstHandleClick(tab, event) {
      this.firstActiveName = tab.name
      this.activeName = 'picture'
    },
    handleClick(tab, event) {
      this.activeName = tab.name
    },
    // 展开评估类型下拉
    onShowMore() {
      this.$nextTick(() => {
        this.isShowMore = !this.isShowMore
        this.initialKey += 1
      })
    },
    // 隐藏/查看标准
    changeShow() {
      this.isShow = !this.isShow
      this.tableKey += 1
      this.$refs.scoreTable.doLayout()
      this.$forceUpdate()
    },
    onDownload() {
      reportApi.exportForUpload(this.sensoryReportId).then(fileService.respToFile);
    },
    onImport() {
      this.dialogBatchUploadVisible = true
      this.uploadForm.fileName = ''
      this.fileList = []
      this.uploadListsUrl = process.env.VUE_APP_SERVER_BASE_URL + `/process-sensory-report/importScoreDetails/${this.sensoryReportId}`
    },
    onExport() {
      reportApi.exportForUpload(this.sensoryReportId).then(fileService.respToFile);
    },
    scoresPlaceholder(val) {
      return val ? "" : "多值请用逗号分隔      例如:1(内容),2(内容)"
    },
    // 分数校验
    scoreRange(rule, value, callback) {
      console.log('value :', value);
      if (commonFun.isEmpty(value)) {
        return callback(new Error(this.$t("common.canNotBeEmpty")));
      }
      let reg = /\[(\d)+\]/g;
      let templateDetailIndex = null;
      let res = null;
      while (res = reg.exec(rule.field)) {
        templateDetailIndex = res[0].substr(1, res[0].length - 2);
      }
      console.log('templateDetailIndex :', templateDetailIndex);
      console.log('this.tableForm.templateData :', this.tableForm.templateData);
      let templateDetail = this.tableForm.templateData.filter(templateDetail => templateDetail.index == templateDetailIndex)[0];
      console.log('templateDetail :', templateDetail);
      let start = templateDetail.start;
      console.log('start :', start);
      let end = templateDetail.end;
      console.log('end :', end);
      if (Number.isNaN(value - 0) || value < start || value > end) {
        return callback(new Error(this.$t("sensory.report.scoreRangeErr", { start: start, end: end })));
      } else {
        return callback();
      }
    },
    // 保存
    save() {
      let report = this.prepareSaveData();
      report.files = this.picTableData.concat(this.fileTableData)
      console.log("GY🚀 ~ save ~ report:", report);
      if (report) {
        reportApi.save(report).then(resp => {
          console.log('resp2 :', resp);
          if (resp.meta.code == '200') {
            this.$message({
              message: this.$t("common.saveSuccess"),
              type: "success"
            });
            if (this.$route.name != 'processSensoryReportDetail') {
              this.$router.replace({ path: `/processSensoryReport-edit/${resp.data}` });
            }
            this.getData();
          } else {
            Message.error(resp.meta.code);
          }
        })
      }
    },

    submit() {
      let errorFlag = this.tableForm.tableHeadData.some(batch => !batch.rateDate)
      console.log('errorFlag :', errorFlag);
      if (errorFlag) {
        this.$message.error('请选择评估日期')
        return false;
      }
      this.$refs["tableForm"].validate(valid => {
        if (valid) {
          let report = this.prepareSaveData();
          report.files = this.picTableData.concat(this.fileTableData)
          if (report) {
            if (report.sensoryReportPlantBatchs.length < 1) {
              this.$message({
                message: '请添加工厂',
                type: "error"
              });
            } else {
              reportApi.submit(report).then(resp => {
                if (resp.meta.code == '200') {
                  this.$message({
                    message: this.$t("common.submitSuccess"),
                    type: "success"
                  });
                  this.$router.push({ path: `processSensoryReport` })
                } else {
                  Message.error(resp.meta.code);
                }
              })
            }
          }
        } else {
          this.$message.error('请完善评估明细必填项')
        }
      });
    },
    changeSubmit() {
      let errorFlag = this.tableForm.tableHeadData.some(batch => !batch.rateDate)
      console.log('errorFlag :', errorFlag);
      if (errorFlag) {
        this.$message.error('请选择评估日期')
        return false;
      }
      this.$refs["tableForm"].validate(valid => {
        if (valid) {
          let report = this.prepareSaveData();
          report.files = this.picTableData.concat(this.fileTableData)
          if (report) {
            if (report.sensoryReportPlantBatchs.length < 1) {
              this.$message({
                message: '请添加工厂',
                type: "error"
              });
            } else {
              this.submitDialogVisible = true
              this.changeForm.reportNo = this.report.reportNo
            }
          }
        } else {
          this.$message.error('请完善评估明细必填项')
        }
      })
    },
    submitForm() {
      let report = this.prepareSaveData();
      console.log('report :', report);
      report.files = this.picTableData.concat(this.fileTableData)
      report.updateReason = this.changeForm.updateReason
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          reportApi.submit(report).then(resp => {
            if (resp.meta.code == '200') {
              this.$message({
                message: this.$t("common.submitSuccess"),
                type: "success"
              });
              this.submitDialogVisible = false
              this.changeForm.reportNo = ''
              this.$router.push({ path: `processSensoryReport` })
            } else {
              Message.error(resp.meta.code);
            }
          })
        }
      })
    },
    onCancel() {
      this.submitDialogVisible = false
      this.changeForm.reportNo = ''
    },
    rateDateChange(val, batchIndex) {
      console.log('batchIndex :', batchIndex);
      console.log('val :', val);
      // this.tableForm.tableHeadData
      console.log('this.tableForm.tableHeadData :', this.tableForm.tableHeadData);
      if (val && batchIndex == 0) {
        this.tableForm.tableHeadData.forEach((ele, index) => {
          if (!ele.rateDate && index != 0) {
            this.$set(ele, 'rateDate', val)
          }
        })
      }
    },
    prepareSaveData() {
      let tableHeadData = this.tableForm.tableHeadData;
      console.log('prepareSaveData~tableHeadData :', tableHeadData);
      let batches = [];
      let batchIndex = 0;
      tableHeadData.forEach(batch => {
        let value = Object.values(batch.scores).join(";")
        batch.score = value;
        batch.appearanceScore = commonFun.trim(this.countScore("AppearanceScore", batch), "%");
        batch.textureScore = commonFun.trim(this.countScore("TextureScore", batch), "%");
        batch.flavorScore = commonFun.trim(this.countScore("FlavorScore", batch), "%");
        batch.productQualityScore = commonFun.trim(this.countScore("QualityScore", batch), "%");
        batch.sort = batchIndex++;
        batches.push(batch);
      });
      this.report.version = this.version
      let report = {
        sensoryReport: this.report,
        sensoryReportPlantBatchs: batches
      };
      return report;
    },
    spanMethod({ row, column, rowIndex, columnIndex }) {
      let batchSize = 0;
      this.tableForm.tableHeadData.forEach(value => {
        batchSize++;
      })
      if (row.detailType == 'TITLE' && columnIndex == 1) {
        return [1, 1 + batchSize]
      }
    },
    cellClassNameFun({ row, column, rowIndex, columnIndex }) {
      if (row.detailType == 'TITLE') {
        if (columnIndex == 0) {
          return "title";
        } else if (columnIndex == 1) {
          return "title-desc";
        }
      } else if (Number(this.version) > 1 && row.detailType !== 'TITLE' && row.detailType !== 'SCORE') {
        // 动态计算批次列的起始索引：显示标准列时从2开始，隐藏时从1开始
        const batchColumnStart = this.isShow ? 2 : 1;
        if (columnIndex >= batchColumnStart) {
          // 计算当前列对应的批次索引（减去起始索引）
          const batchIndex = columnIndex - batchColumnStart;
          // 校验批次索引有效性（避免越界）
          if (batchIndex >= 0 && batchIndex < this.tableForm.tableHeadData.length) {
            const batch = this.tableForm.tableHeadData[batchIndex];
            console.log('batch :', batch);
            if (batch) {
              if (batch.score && batch.lastScore) {
                // 获取当前行对应的分数和历史分数
                const currentScore = batch.scores[row.index];
                const lastScore = batch.lastScores[row.index];
                console.log('currentScore-lastScore1 :', currentScore, lastScore);
                // 比较分数（考虑空值情况）
                if (currentScore !== lastScore) {
                  return 'warning-row'; // 返回差异样式类名
                }
              }

            }
          }
        }
      }
      return '';
    },
    rowClassNameFun({ row, rowIndex }) {
      if (row.detailType == 'TITLE') {
        return "title";
      }
    },
    toList() {
      this.$router.push({
        path: "/sensoryReport",
      });
    },
  },
}
</script>
<style lang="scss" scoped>
.table_header_grandFather {
  min-width: 250px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .table_header_father {
    flex: 1;
    padding: 0;
    margin-right: 5px;
    .table_header_input {
      padding: 0;
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 100%;
      .table_header_input_label {
        width: 60px;
        padding-left: 0;
        text-align: right;
      }
      .table_header_input_content1 {
        padding: 0;
        display: flex;
        justify-content: space-around;
        align-items: center;
        width: calc(100% - 60px) !important;
      }
    }
  }
}
</style>
<style>
.template-detail {
  padding: 0 !important;
}

.template-detail-cell {
  width: 11.111111%;
  display: inline-block;
  text-align: center !important;
}
.template-detail-cell.row2:before {
  content: " ";
  display: inline-block;
}

.template-detail-cell.row2 {
  border-top: 1px solid #ebeef5;
}

.template-detail-cell.row2:not(:first-child) {
  border-left: 1px solid #ebeef5;
}

tr.title td {
  font-weight: bold;
  font-style: oblique;
}
.el-table thead.is-group th {
  padding: 2px 0;
}
.colorBtn .el-button {
  background: #f8ab01 !important;
  color: #fff !important;
  border-color: #f8ab01 !important;
}
</style>
<style scoped lang="scss">
.el-select {
  width: 100%;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
</style>
<style lang="scss">
.scoreTable {
  .el-table__row .template-detail .cell {
    white-space: pre-wrap;
    text-align: left;
    line-height: 26px;
  }
  textarea {
    resize: none;
  }
  .score input {
    text-align: center;
  }

  .el-table--small td,
  .el-table--small th {
    padding: 0 !important;
  }

  .el-table td:not(.template-detail) .cell,
  .supplierSelfEvaluation .el-table td.detail-comments .cell,
  .supplierSelfEvaluation .el-table td.title .cell,
  .supplierSelfEvaluation .el-table td.title-desc .cell {
    line-height: 40px;
  }
  .el-table th div {
    overflow: visible;
  }
}
</style>

